// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3zZ30","signatureBlock":"Footer_signatureBlock__BI96K","signature":"Footer_signature__1Cdd6"};